import { useEffect, useState } from "react";
import axios from "axios";
import VehicleCard from "@/components/VehicleCard";
import { enquireVehicle } from "@/components/Stock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FeaturedVehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/vehicles`, { params: { featured: true } })
      .then((res) => setVehicles(res.data))
      .catch(() => setVehicles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="destaques" data-testid="featured-section" className="py-20 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div>
            <p className="text-xs font-semibold tracking-[0.35em] uppercase text-slate-500 mb-4">
              Seleção Premium
            </p>
            <h2
              data-testid="featured-heading"
              className="font-display text-3xl sm:text-4xl tracking-tight text-[#0072C6]"
            >
              Viaturas em Destaque
            </h2>
          </div>
          <a
            href="#stock"
            data-testid="featured-view-all"
            className="text-sm font-semibold text-[#0072C6] border-b-2 border-[#0072C6] pb-1 hover:text-[#005FA3] hover:border-[#005FA3] transition-colors self-start sm:self-auto"
          >
            Ver todo o stock
          </a>
        </div>

        {loading ? (
          <div className="py-16 text-center text-slate-400 text-sm" data-testid="featured-loading">
            A carregar destaques…
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="featured-grid">
            {vehicles.map((v) => (
              <VehicleCard key={v.id} vehicle={v} onEnquire={enquireVehicle} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
